import React             from 'react'; // React imports
import ReactDOM          from 'react-dom'; // React imports
import { Provider }      from 'react-redux'; // Redux HOC
import { BrowserRouter } from 'react-router-dom'; // React Router
import App               from './App'; // Root component
import deviceState       from './app/device_state/index'; // Responsive view states
import store             from "./redux/index"; // Redux Store

new deviceState(store.dispatch); // Pass redux dispatch to device state

ReactDOM.render((
    <BrowserRouter basename="/react_ins">
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
), document.getElementById('root'));
